export default __webpack_public_path__ + "static/media/icon-upload-image.4054a0a1.svg";